import { useListenScrollDirection } from "@/utils/hooks/useListenScrollDirection";
import classNames from "classnames";
import { useState } from "react";
import styles from "./index.module.less";

interface ScrollHeaderProps {
  children: React.ReactNode;
  headerHeight: number;
  tabRef: React.RefObject<HTMLElement>;
  isTop?: boolean;
}

/**
 * 滚动展示Header组件，往下滚动一定距离后再往上滚动展示
 * @param children 子组件
 * @param headerHeight 搜索导航栏头部高度
 * @param tabRef 参考元素
 * @param isTop 参考元素是顶部还是底部
 */
export function ScrollHeader({
  children,
  headerHeight,
  tabRef,
  isTop = false,
}: ScrollHeaderProps) {
  const [visible, setVisible] = useState(false);

  useListenScrollDirection(
    () => {
      const rect = tabRef.current?.getBoundingClientRect();
      const showHeader = isTop
        ? rect?.top <= headerHeight
        : rect?.bottom <= headerHeight;
      setVisible(showHeader);
    },
    () => {
      const rect = tabRef.current?.getBoundingClientRect();
      const showHeader = isTop
        ? rect?.top - headerHeight <= 0 && rect?.top - headerHeight >= -120
        : rect?.bottom - headerHeight <= 0;
      setVisible(showHeader);
    }
  );

  return (
    <div
      className={classNames(styles.header, {
        [styles.active]: visible,
      })}
    >
      <div className={styles.leftPlaceholder}></div>
      {children}
    </div>
  );
}
